import { css } from 'lit';

export const styles = css`
	:host {
		--_sds-chip-font-family: var(--sds-chip-font-family, var(--sds-typography-font-family-roboto));
		--_sds-chip-font-weight: var(--sds-chip-font-weight, var(--sds-typography-font-weight-regular));
		--_sds-chip-font-size: var(--sds-chip-font-size, var(--sds-components-font-size-content-md));
		--_sds-chip-line-height: var(--sds-chip-line-height, var(--sds-components-line-height-squeezed-md));
		--_sds-chip-height: var(--sds-chip-height, var(--sds-components-chip-md));

		--_sds-chip-gap: var(--sds-chip-gap, var(--sds-spacing-4xs));
		--_sds-chip-padding-inline: var(--sds-chip-padding-inline, var(--sds-spacing-2xs));

		--_sds-chip-border-color: var(--sds-chip-border-color, var(--sds-color-border-default, var(--sds-color-main-border-default)));
		--_sds-chip-border-width: var(--sds-chip-border-width, var(--sds-border-sm));
		--_sds-chip-border-radius: var(--sds-chip-border-radius, var(--sds-radius-full));

		--_sds-chip-focus-outline-width: var(--sds-chip-focus-outline-width, var(--sds-border-md));
		--_sds-chip-focus-outline-color: var(--sds-chip-focus-outline-color, var(--sds-color-states-focus-outer));
		--_sds-chip-focus-outline-offset: var(--sds-chip-focus-outline-offset, var(--sds-color-states-focus-spacing));
		--_sds-chip-focus-inner-color: var(--sds-chip-focus-inner-color, var(--sds-color-states-focus-inner));

		--_sds-chip-disabled-opacity: var(--sds-chip-disabled-opacity, var(--sds-color-states-disabled-opacity));

		--_sds-chip-background-color: var(--sds-chip-background-color, var(--sds-color-surface-tinted, var(--sds-color-main-surface-tinted)));
		--_sds-chip-text-color: var(--sds-chip-text-color, var(--sds-color-text-default, var(--sds-color-main-text-default)));

		display: inline-block;
		box-sizing: border-box;

		::slotted(sds-icon),
		sds-icon {
			--sds-icon-color: var(--_sds-chip-text-color);
		}
	}

	:host([disabled]) {
		opacity: var(--_sds-chip-disabled-opacity);
		cursor: not-allowed;
		pointer-events: none;
	}

	:host(:hover) {
		--_sds-chip-background-color: var(--sds-chip-background-color, var(--sds-color-surface-hover, var(--sds-color-main-surface-hover)));
		--_sds-chip-border-color: var(--sds-chip-border-color, var(--sds-color-action-default, var(--sds-color-main-action-default)));
	}

	:host(:active) {
		--_sds-chip-background-color: var(--sds-chip-background-color, var(--sds-color-surface-active, var(--sds-color-main-surface-active)));
		--_sds-chip-border-color: var(--sds-chip-border-color, var(--sds-color-action-default, var(--sds-color-main-action-default)));
	}

	:host([checked]) {
		--_sds-chip-background-color: var(--sds-chip-background-color, var(--sds-color-action-default, var(--sds-color-main-action-default)));
		--_sds-chip-border-color: var(--sds-chip-border-color, var(--sds-color-action-default, var(--sds-color-main-action-default)));
		--_sds-chip-text-color: var(--sds-chip-text-color, var(--sds-color-main-action-contrast-default));
	}

	:host([checked]:hover) {
		--_sds-chip-background-color: var(--sds-chip-background-color, var(--sds-color-action-hover, var(--sds-color-main-action-hover)));
		--_sds-chip-text-color: var(--sds-chip-text-color, var(--sds-color-main-action-contrast-default));
		--_sds-chip-border-color: var(--sds-chip-border-color, var(--sds-color-action-hover, var(--sds-color-main-action-hover)));
	}

	:host([checked]:active) {
		--_sds-chip-background-color: var(--sds-chip-background-color, var(--sds-color-action-active, var(--sds-color-main-action-active)));
		--_sds-chip-border-color: var(--sds-chip-border-color, var(--sds-color-action-active, var(--sds-color-main-action-active)));
	}

	:host([size='sm']) {
		--_sds-chip-padding-inline: var(--sds-chip-padding-inline, var(--sds-spacing-2xs));
		--_sds-chip-font-size: var(--sds-chip-font-size, var(--sds-components-font-size-content-sm));
		--_sds-chip-line-height: var(--sds-chip-line-height, var(--sds-components-line-height-squeezed-sm));
		--_sds-chip-height: var(--sds-chip-height, var(--sds-components-chip-sm));
	}

	:host([size='lg']) {
		--_sds-chip-padding-inline: var(--sds-chip-padding-inline, var(--sds-spacing-2xs));
		--_sds-chip-font-size: var(--sds-chip-font-size, var(--sds-components-font-size-content-lg));
		--_sds-chip-line-height: var(--sds-chip-line-height, var(--sds-components-line-height-squeezed-lg));
		--_sds-chip-height: var(--sds-chip-height, var(--sds-components-chip-lg));
	}

	.sds-chip {
		align-items: center;
		display: inline-flex;
		height: var(--_sds-chip-height);
		gap: var(--_sds-chip-gap);
		justify-content: center;
		padding-inline: var(--_sds-chip-padding-inline);

		background-color: var(--_sds-chip-background-color);
		border: var(--_sds-chip-border-width) solid var(--_sds-chip-border-color);
		border-radius: var(--_sds-chip-border-radius);

		font-family: var(--_sds-chip-font-family);
		font-size: var(--_sds-chip-font-size);
		font-weight: var(--_sds-chip-font-weight);
		line-height: var(--_sds-chip-line-height);
		text-align: center;
		color: var(--_sds-chip-text-color);
		box-sizing: border-box;

		user-select: text;
		cursor: pointer;

		&:focus-within,
		&:focus {
			box-shadow: 0 0 0 var(--sds-color-states-focus-spacing) var(--_sds-chip-focus-inner-color);
			outline: var(--_sds-chip-focus-outline-width) solid var(--_sds-chip-focus-outline-color);
			outline-offset: var(--_sds-chip-focus-outline-offset);
		}

		&:has([readonly]) {
			cursor: default;
		}

		&.sds-chip--removable {
			--_sds-chip-background-color: var(--sds-chip-background-color, var(--sds-color-action-default, var(--sds-color-main-action-default)));
			--_sds-chip-text-color: var(--sds-chip-text-color, var(--sds-color-main-action-contrast-default));
			--_sds-chip-border-color: var(--sds-chip-border-color, var(--sds-color-action-default, var(--sds-color-main-action-default)));

			&:hover {
				--_sds-chip-background-color: var(--sds-chip-background-color, var(--sds-color-action-hover, var(--sds-color-main-action-hover)));
				--_sds-chip-text-color: var(--sds-chip-text-color, var(--sds-color-main-action-contrast-default));
				--_sds-chip-border-color: var(--sds-chip-border-color, var(--sds-color-action-hover, var(--sds-color-main-action-hover)));
			}

			&:active {
				--_sds-chip-background-color: var(--sds-chip-background-color, var(--sds-color-action-active, var(--sds-color-main-action-active)));
				--_sds-chip-text-color: var(--sds-chip-text-color, var(--sds-color-main-action-contrast-default));
				--_sds-chip-border-color: var(--sds-chip-border-color, var(--sds-color-action-active, var(--sds-color-main-action-active)));
			}
		}

		& input[type='checkbox'] {
			position: absolute;
			width: 1px;
			height: 1px;
			padding: 0;
			margin: -1px;
			overflow: hidden;
			clip-path: inset(50%);
			border: 0;
			white-space: nowrap;
		}
	}
`;
